// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"8a155b6b143bf2ac9f79","245":"c1f29081013a632d1574","452":"6d814279f07ca7dae550","453":"3ff11df11ec25050bcd3","577":"c77a02597c87fe518ac9"}[chunkId] + ".js";
};